import { PopperState } from "./gamestate/PopperState";
import { ClickAwayListener } from "./gameLib/ClickAwayListener";


/*
    Popper object is used for elements hovering the game.
    When using, it is mandatory to call the open() and close() methods to maintain correct game state.
    The removeFromCanvas method should dispose of the popper class, without managing state.
*/ 
export abstract class Popper{
    
    private state : PopperState;
    private clickAwayListener: ClickAwayListener;

	constructor(state:PopperState) 
	{
		this.state=state;

	}

    public addClickAwayListener(clickAwayListener: ClickAwayListener){
        this.clickAwayListener = clickAwayListener; 
       
    }

    public open(): void{
        
        
        this.state.addOpenPopper(this);
        if(this.clickAwayListener != null ){
            this.clickAwayListener.activate();
        }
    }

    public close(): void {

      
        if(this.clickAwayListener != null ){
            this.clickAwayListener.desactivate();
        }
        this.removeFromCanvas();
        this.state.disposePopper(this);
    }

    
    abstract removeFromCanvas(): void ;
}

